import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './FrameSelector.css';

export const FRAME_OPTIONS = [
  { id: 'black', label_en: 'Black', label_es: 'Negro', color: '#1a1a1a', ring: '#0a0a0a' },
  { id: 'silver', label_en: 'Silver', label_es: 'Plateado', color: '#c8c8c8', ring: '#a8a8a8' },
  { id: 'gold', label_en: 'Gold', label_es: 'Dorado', color: '#c9a961', ring: '#a98a3e' },
];

export const getFrameLabel = (frameId, lang) => {
  const opt = FRAME_OPTIONS.find((o) => o.id === frameId);
  if (!opt) return '';
  return lang === 'es' ? opt.label_es : opt.label_en;
};

const FrameSelector = ({ value, onChange, testId = 'frame' }) => {
  const { t, lang } = useLanguage();
  const selected = value || 'black';

  return (
    <div className="frame-selector" data-testid={`${testId}-selector`}>
      <span className="frame-selector-label">{t('frame_choose')}</span>
      <div className="frame-swatches" role="radiogroup" aria-label={t('frame_choose')}>
        {FRAME_OPTIONS.map((opt) => (
          <button
            type="button"
            key={opt.id}
            role="radio"
            aria-checked={selected === opt.id}
            data-testid={`${testId}-${opt.id}`}
            className={`frame-swatch-wrap ${selected === opt.id ? 'active' : ''}`}
            onClick={() => onChange(opt.id)}
          >
            <span
              className="frame-swatch"
              style={{ '--swatch-color': opt.color, '--swatch-ring': opt.ring }}
            >
              <span className="frame-swatch-inner" />
            </span>
            <span className="frame-swatch-name">
              {lang === 'es' ? opt.label_es : opt.label_en}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default FrameSelector;
